export const badgeSizes = {
   Small: {
      typography: 'text-xs-medium',
      padding: 'py-2px',
      paddingLeft: 'pl-8px',
      paddingRight: 'pr-8px',
      leftIconMargin: 'ml-6px mr-4px',
      rightIconMargin: 'ml-4px mr-6px',
      badgeBorder: 'border-1.5px border-solid',
      borderRadius: 'rounded-16px',
      dotLeftMargin: 'ml-6px mr-4px'
   },
   Medium: {
      typography: 'text-sm-medium',
      padding: 'py-2px',
      paddingLeft: 'pl-10px',
      paddingRight: 'pr-10px',
      leftIconMargin: 'ml-8px mr-4px',
      rightIconMargin: 'ml-4px mr-6px',
      badgeBorder: 'border-1.5px border-solid',
      borderRadius: 'rounded-16px',
      dotLeftMargin: 'ml-8px mr-6px'
   },
   Large: {
      typography: 'text-sm-medium',
      padding: 'py-4px',
      paddingLeft: 'pl-12px',
      paddingRight: 'pr-12px',
      leftIconMargin: 'ml-10px mr-4px',
      rightIconMargin: 'ml-4px mr-8px',
      badgeBorder: 'border-1.5px border-solid',
      borderRadius: 'rounded-16px',
      dotLeftMargin: 'ml-10px mr-6px'
   }
}
